import { address as mainAddress, abi as mainAbi } from '../contract/dev/main'
import { address as customAddress, abi as customAbi } from '../contract/dev/custom'
import { network } from '../network/dev'
export default {
  env: 'dev',
  baseUrl: 'http://mathew.natapp1.cc',
  isEnableEncryption: false, //是否加密
  isLog: true, //是否打印日志
  isVerifyToken: false, //是否验证token 不验证则跳转首页 写页面的时候设置为false 就不会拉起小狐狸
  debugCode:'', //调试的时候邀请码
  address:'', //测试网有数据账号地址 默认空
  isNotice: false, //是否显示通知
  suffix:'4cf4c22f6e6ce089937de71339f1b87d', //后端统一拦截路由
  // 主合约 一般是测试网或者主网的usdt合约
  main: {
    address: mainAddress,
    abi: mainAbi
  },
  // 自定义合约 一般是自己写的合约
  custom: {
    address: customAddress,
    abi: customAbi
  },
  network
};
